import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: 35,
        marginBottom: 30,
        width: '90%'
    },
    buttonContainer: {
        width: 430,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    buttonRow: {
        display: 'flex',
        margin: '10px 0 10px 0',
        justifyContent: 'space-between',
    },
    button: {
        width: 130,
        height: 130,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'

    },
    buttonIcon: {
        width: 45,
        height: 45,
        marginTop: 15,
        marginBottom: 10
    },
    buttonLabel: {
        color: theme.palette.secondary.main,
        fontSize: 22,
        fontWeight: 'bold',
        height: 52,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '90%',
        lineHeight: 1.2,
        textDecoration: 'none'
    },
    footer: {
        width: '100%',
        marginTop: 'auto',
        marginBottom: 20
    },
    footerButton: {
        width: '75%'
    }
}));

export default useStyles;